import { useQuery } from 'react-query';
import { api, useApi } from 'hooks';
import { formatBounds } from 'utils/format';

/**
 * This is a temporary API file for APIs that don't fit anywhere else, but
 * currently live in our backend service.
 *
 * The goal is to move these requests into their own services as the services
 * are created.
 */

type FetchPolygonsByZoneType = {
  bounds: google.maps.LatLngBoundsLiteral;
  cityId: number;
  zoneOverlayName: string;
};

export type ZoneNamesAndCity = {
  city_id: number;
  zone_overlay_name: string;
};

export const fetchPolygonsByZone = async ({
  bounds,
  cityId,
  zoneOverlayName,
}: FetchPolygonsByZoneType) => {
  const response = await api.post<Record<string, []> | null>(`districts/polygons/`, {
    bbox: formatBounds(bounds),
    city_id: cityId,
    zone_overlay_name: zoneOverlayName,
  });

  return response.data || {};
};

export const usePolygonOverlayNamesByRegion = (regionId: string) => {
  const authedApi = useApi();

  const polygonOverlayNames = useQuery(
    ['polygon-overlay-names-by-region', regionId],
    async () => {
      const result = await authedApi.get<ZoneNamesAndCity[]>(
        `districts/region/${regionId}/names/`,
      );

      return result;
    },
    { refetchOnWindowFocus: false },
  );

  return polygonOverlayNames;
};
